module.exports = __webpack_public_path__ + "img/040-thermometer-2.b73d0ab9.svg";